import { AlertTriangle } from 'lucide-react'
import { aiProviderLogo, legacyProviderWarning } from '@/lib/ai-providers'
import { useTranslation } from 'react-i18next'

/** Logo + tên nền tảng AI, dùng trong ô chọn / thẻ nền tảng. */
export function AiProviderOption({ id, name }: { id: string; name: string }) {
  const logo = aiProviderLogo(id)
  return (
    <span className="inline-flex items-center gap-2">
      {logo && (
        <img
          src={logo}
          alt=""
          aria-hidden
          draggable={false}
          className="h-4 w-4 shrink-0 rounded-[3px] bg-white object-contain p-px"
        />
      )}
      <span>{name}</span>
    </span>
  )
}

/** Cảnh báo nhân viên AI / cấu hình đang dùng nền tảng đã bỏ — buộc chọn lại. */
export function LegacyProviderWarning({ provider }: { provider: string }) {
  const { t } = useTranslation()
  return (
    <p role="alert" className="flex items-center gap-1.5 text-xs text-warning">
      <AlertTriangle className="h-3.5 w-3.5 shrink-0" />
      {legacyProviderWarning()} ({t('aiMisc:aiProviders.currentlyUsing', { provider })})
    </p>
  )
}
